import { ActionTypes } from "store/actionTypes";

type Guide = { id: string | number; [key: string]: any };

const initialState: {
  isLoading: boolean;
  error: string | null;
  guides: Guide[];
  selectedGuide: Guide | null;
  selectedCustomerId: string | null;
} = {
  isLoading: false,
  error: null,
  guides: [],
  selectedGuide: null,
  selectedCustomerId: null,
};

const guideReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.GUIDE_LOADING:
      return { ...state, isLoading: true, error: null };
    case ActionTypes.GUIDE_ERROR:
      return { ...state, isLoading: false, error: action.payload };
    case ActionTypes.GET_GUIDES:
      // Ensure guides is always an array
      let guidesData = [];
      if (Array.isArray(action.payload)) {
        guidesData = action.payload;
      } else if (action.payload?.rows && Array.isArray(action.payload.rows)) {
        guidesData = action.payload.rows;
      } else if (action.payload && Array.isArray(action.payload)) {
        guidesData = action.payload;
      }
      return {
        ...state,
        isLoading: false,
        guides: guidesData,
      };
    case ActionTypes.GET_GUIDE_BY_ID:
      return { ...state, isLoading: false, selectedGuide: action.payload };
    case ActionTypes.ADD_GUIDE:
      return {
        ...state,
        isLoading: false,
        guides: [...state.guides, action.payload],
      };
    case ActionTypes.UPDATE_GUIDE:
      return {
        ...state,
        isLoading: false,
        guides: state.guides.map((g) =>
          g.id === action.payload.id ? { ...g, ...action.payload } : g
        ),
        selectedGuide:
          state.selectedGuide?.id === action.payload.id
            ? { ...state.selectedGuide, ...action.payload }
            : state.selectedGuide,
      };
    case ActionTypes.DELETE_GUIDE:
      return {
        ...state,
        isLoading: false,
        guides: state.guides.filter((g) => g.id !== action.payload),
        selectedGuide:
          state.selectedGuide?.id === action.payload ? null : state.selectedGuide,
      };
    case ActionTypes.SET_GUIDE_CUSTOMER_SELECTION:
      return {
        ...state,
        selectedCustomerId: action.payload,
      };
    default:
      return state;
  }
};

export default guideReducer;
